import React, { Component } from 'react';

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import DispatchReportService from '../../services/DispatchReportService';
import tableRequest from '../../models/tableRequest.js';

import MessageComponent from '../../template/Message';

export default class MigoReport extends Component {

    constructor(props) {
        super(props);

        this.DispatchReportService = new DispatchReportService();
        this.tblResponse = new tableRequest();

        this.state = {
            FromDate: new Date(),
            ToDate: new Date(),
            sales: [],
            first: 0,
            rows: 10,
            totalRecords: 0
        };
    }

    componentDidMount() {

        let date = new Date();
        date.setDate(date.getDate() - 7);

        this.setState({
            FromDate: date,
            ToDate: new Date()
        });

        this.tblResponse.FromDate = date.toLocaleDateString();
        this.tblResponse.ToDate = new Date().toLocaleDateString();

        this.tblResponse.PageSize = 10;
        this.tblResponse.First = 1;

        this.GetDispatch();
    }

    // ================= API CALL =================
    GetDispatch = () => {

        this.DispatchReportService.GetMigoReport(this.tblResponse)
            .then(res => {

                const response = res?.data;

                const list =
                    response && Array.isArray(response.ResponseData)
                        ? response.ResponseData
                        : [];

                this.setState({
                    sales: list,
                    totalRecords: list.length > 0 ? list[0].TotalRows : 0
                });

            })
            .catch(err => {

                console.log(err);

                this.setState({
                    sales: [],
                    totalRecords: 0
                });
            });
    };

    // ================= PAGINATION =================
   onPage = (event) => {

    this.setState({
        first: event.first,
        rows: event.rows
    });

    this.tblResponse.First = event.first;     // ✅ MUST SEND THIS
    this.tblResponse.PageSize = event.rows;   // ✅ OK

    this.GetDispatch();
};

    // ================= SEARCH =================
    searchFilter = (e) => {

        this.tblResponse.SearchValue = e.target.value;
        this.tblResponse.First = 1;

        this.setState({
            first: 0
        });

        this.GetDispatch();
    };

    // ================= FILTER =================
    FilterData = () => {

        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.tblResponse.First = 1;

        this.setState({
            first: 0
        });

        this.GetDispatch();
    };

    // ================= HEADER =================
    renderHeader = () => (
        <div className="row mb-3">

            <div className="col-md-8 d-flex gap-2">

                <Calendar
                     value={this.state.FromDate}
    onChange={(e) => this.setState({ FromDate: e.value })}
    showIcon
    dateFormat="dd/mm/yy"
    appendTo={document.body}
                />

                <Calendar
                    value={this.state.ToDate}
    onChange={(e) => this.handleDateChange('ToDate', e.value)}
    showIcon
    dateFormat="dd/mm/yy"
    appendTo={document.body}
                />

                <Button label="Submit" onClick={this.FilterData} />

            </div>

            <div className="col-md-4 text-end">
                <InputText
                    placeholder="Search"
                    onInput={this.searchFilter}
                />
            </div>

        </div>
    );

    render() {

        return (
            <>
                <MessageComponent ref="Messchild" />

                <h3>MIGO Report</h3>

                <DataTable
                    value={this.state.sales}
                    paginator
                    lazy
                    first={this.state.first}
                    rows={this.state.rows}
                    totalRecords={this.state.totalRecords}
                    onPage={this.onPage}
                    rowsPerPageOptions={[10, 20, 50]}
                    header={this.renderHeader()}
                    emptyMessage="No Data Found"
                >

                    <Column field="MigoNumber" header="MIGO No" />
                    <Column field="MigoDate" header="MIGO Date" />
                   
                    
                    <Column field="Plant" header="Plant" />
                    <Column field="DeliveryNo" header="OBD No" />
                    <Column field="ObdDate" header="OBD Date" />
                    <Column field="RefNo" header="Ref No" />

                </DataTable>

            </>
        );
    }
}